import { render, staticRenderFns } from "./ExamDetail.vue?vue&type=template&id=4412e86e&scoped=true&"
import script from "./ExamDetail.vue?vue&type=script&lang=js&"
export * from "./ExamDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExamDetail.vue?vue&type=style&index=0&id=4412e86e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4412e86e",
  null
  
)

component.options.__file = "ExamDetail.vue"
export default component.exports